"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateTypoSystem = void 0;
var constants_1 = require("../constants");
var utils_1 = require("../utils");
var generateFile_1 = require("./generateFile");
/**
 * Генерация типографики в по типам устройств для создания глобального стиля.
 * @param {Record<string, CSSRootTheme>} typoThemes Типографика, разложенная по типам устройств
 * @return {GeneratedFiles}
 */
var generateTypoSystem = function (typoThemes, mixin) {
    if (mixin === void 0) { mixin = {}; }
    var files = [];
    var withPrefixDesign = true;
    var withKebabCase = true;
    var indexContent = '';
    for (var _i = 0, _a = Object.entries(typoThemes); _i < _a.length; _i++) {
        var _b = _a[_i], fileName = _b[0], _c = _b[1], theme = _c.theme, _d = _c.scale, scale = _d === void 0 ? 1 : _d;
        indexContent += "export { ".concat(fileName, " } from './").concat(fileName, "';\n");
        files.push((0, generateFile_1.generateFile)(fileName, (0, utils_1.attachToRoot)(__assign(__assign(__assign(__assign({}, (0, utils_1.objectToCSSVariables)(theme, 'typo', withPrefixDesign, withKebabCase)), (0, utils_1.objectToCSSVariables)(mixin, '', withPrefixDesign, withKebabCase)), {
            '--plasma-typo-overflow-wrap': 'break-word',
            '--plasma-typo-hyphens': 'auto',
        }), { fontSize: "".concat(constants_1.HTML_FONT_SIZE * scale, "px") }))));
    }
    files.push({
        file: 'index.ts',
        content: indexContent,
    });
    return files;
};
exports.generateTypoSystem = generateTypoSystem;
//# sourceMappingURL=generateTypoSystem.js.map